import FuzzySearch from "fuzzy-search";
// all values must be strings or it will crash
export const fuzzSearch = (searchValue, arrayToSearch, propertiesToSearch) => {
  let options = { caseSensitive: false };

  let results = [];

  try {
    const searchObject = new FuzzySearch(
      arrayToSearch,
      propertiesToSearch,
      options
    );
    results = searchObject.search(searchValue);
  } catch (e) {
    results = [];
  }

  return results;
};

export const getKeyByValue = (value, obj) => {
  let foundKey = Object.keys(obj).find((key) => obj[key] === value);
  if (typeof foundKey === "undefined") {
    console.warn(`No key for ${value} in ${JSON.stringify(obj)}`);
  }
  return foundKey;
};

export const getIndexByKey = (key, value, arr) => {
  if (!arr || (arr && !Array.isArray(arr))) {
    throw new TypeError(`Invalid type, ${arr} must be an array`);
  } else {
    try {
      return arr.findIndex((obj) => obj[key] === value);
    } catch (err) {
      return err;
    }
  }
};

export const getArrItemByKey = (key, value, arr) => {
  if (!arr || (arr && !Array.isArray(arr))) {
    throw new TypeError(`Invalid type, ${arr} must be an array`);
  } else {
    try {
      return arr.find((obj) => (obj[key] === value ? obj : null));
    } catch (err) {
      return err;
    }
  }
};

export const searchKeyVal = (
  obj,
  searchTerm,
  caseInsensitive = true,
  searchBy = "all"
) => {
  let matched = [];
  for (const [key, value] of Object.entries(obj)) {
    searchTerm = caseInsensitive ? searchTerm.toLowerCase() : searchTerm;
    const searchTermFormattedAsKey = searchTerm.replaceAll(" ", "");
    let valMatch =
      typeof value === "object" && Array.isArray(value)
        ? value.findIndex((element) =>
            typeof element === "string"
              ? caseInsensitive
                ? element.toLowerCase().includes(searchTerm)
                : element.includes(searchTerm)
              : element === searchTerm
          ) !== -1
        : typeof value === "string"
        ? caseInsensitive
          ? value.toLowerCase().includes(searchTerm)
          : value.includes(searchTerm)
        : value === searchTerm;
    let keyToMatch = caseInsensitive ? key.toLowerCase() : key;
    if (
      (searchBy === "all" &&
        (keyToMatch.includes(searchTermFormattedAsKey) || valMatch)) ||
      (searchBy === "key" && keyToMatch.includes(searchTermFormattedAsKey)) ||
      (searchBy === "value" && valMatch)
    ) {
      matched.push(key);
    }
  }
  return matched;
};

export const searchNestedArrayOfObj = (array, key, value, objKey) => {
  if (!array || (array && !Array.isArray(array))) {
    throw new TypeError(`Invalid type, ${arr} must be an array`);
  } else {
    try {
      for (const obj of array) {
        if (obj[key] === value) {
          return obj;
        }
        if (Array.isArray(obj[objKey])) {
          const result = searchNestedArrayOfObj(
            obj[objKey],
            key,
            value,
            objKey
          );
          if (result) {
            return result;
          }
        }
      }
      return null;
    } catch (err) {
      return err;
    }
  }
};
